var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "vy-table-wrapper" },
    [
      _vm.showEdit
        ? _c("div", { ref: "edit", staticClass: "column-select" }, [
            _c(
              "span",
              {
                ref: "modalToggle",
                staticClass: "modal-opener",
                attrs: { tabindex: "0" },
                on: {
                  click: _vm.showEditColumnsModal,
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.showEditColumnsModal.apply(null, arguments)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-pen" })]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showEdit
        ? _c("selectionModal", {
            attrs: {
              showModal: _vm.showModal,
              modalTitle: "Select Columns",
              options: _vm.modalOptions,
              initialSelectedOptions: _vm.selectedColumns,
              categories: _vm.categories,
              sources: _vm.sources,
            },
            on: {
              "option-selection-cancel": function ($event) {
                _vm.showModal = false
              },
              "option-selection": _vm.handleOptionSelection,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "table", staticClass: "vy-table" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }